import { useMutation } from "react-query";
import { approveRejectAttribute } from "components/attributes/lib/attribute-data";

export const useAcceptRejectAttribute = () => {
    return useMutation(async ({ codingWipKey, attributeUuid, approvalStatus, note }) => {
        const response = await approveRejectAttribute({ codingWipKey, attributeUuid, approvalStatus, note });

        return response;
    });
};
